import encryptAxios from '@/utils/encryptAxios';
import {leapCommunityOrigin} from '@/utils/env';
// 获取当前ip所在城市
export function getAddressByIp () {
    return encryptAxios({
        url: leapCommunityOrigin + '/ipAnalysis/getAddressByIp',
        method: 'GET'
    });
}
